import(/* webpackMode: "eager", webpackExports: ["ChatIconPath"] */ "/vercel/path0/app/[locale]/(main)/chat-icon-path.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/horizontal-navbar-user-avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapPath"] */ "/vercel/path0/app/[locale]/(main)/map-path.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/medium-nav.footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/medium-navbar-collapse.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/medium-navbar-toggle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(main)/navbar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/navbar-visible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NestedPathElementContainer"] */ "/vercel/path0/app/[locale]/(main)/nested-path-element-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PluginPath"] */ "/vercel/path0/app/[locale]/(main)/plugin-path.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostPath"] */ "/vercel/path0/app/[locale]/(main)/post-path.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProtectedPathElement"] */ "/vercel/path0/app/[locale]/(main)/protected-path-element.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchematicPath"] */ "/vercel/path0/app/[locale]/(main)/schematic-path.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/small-navbar-collapse.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/small-navbar-inside-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/small-navbar-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationPathIcon"] */ "/vercel/path0/app/[locale]/(main)/translation-path-icon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(main)/user-display.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerifyPathIcon"] */ "/vercel/path0/app/[locale]/(main)/verify-path-icon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/error-screen.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/hydrated.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/tran.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBarProvider"] */ "/vercel/path0/context/navbar.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSession"] */ "/vercel/path0/context/session.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/layout/is-small.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_xnbi2nfe67rciypvbflggxpbum/node_modules/next/dist/client/image-component.js");
